// Pass View Types
export const FETCH_PASS_VIEW_SAGA = "FETCH_PASS_VIEW_SAGA";
export const FETCH_PASS_VIEW_SUCCESS = "FETCH_PASS_VIEW_SUCCESS";
export const FETCH_PASS_VIEW_FAILURE = "FETCH_PASS_VIEW_FAILURE";
export const SET_PASS_VIEW_LOADING = "SET_PASS_VIEW_LOADING";

// Zone View Types
export const FETCH_ZONE_VIEW_SAGA = "FETCH_ZONE_VIEW_SAGA";
export const FETCH_ZONE_VIEW_SUCCESS = "FETCH_ZONE_VIEW_SUCCESS";
export const FETCH_ZONE_VIEW_FAILURE = "FETCH_ZONE_VIEW_FAILURE";
export const SET_ZONE_VIEW_LOADING = "SET_ZONE_VIEW_LOADING";

// Tilt View Types
export const FETCH_TILT_VIEW_SAGA = "FETCH_TILT_VIEW_SAGA";
export const FETCH_TILT_VIEW_SUCCESS = "FETCH_TILT_VIEW_SUCCESS";
export const FETCH_TILT_VIEW_FAILURE = "FETCH_TILT_VIEW_FAILURE";
export const SET_TILT_VIEW_LOADING = "SET_TILT_VIEW_LOADING";
